<div class="custom-mat-dialog-form custom-mat-dialog_v2">
  <div style="display: flex; justify-content: space-between; align-items: center;">
    <h3>{{title}}</h3>
    @if (headerAction) {
      <button type="button"
        mat-icon-button
        class="header-delete-button"
        (click)="headerAction.onClick()"
        [matTooltip]="headerAction.tooltip">
        <mat-icon>{{headerAction.icon}}</mat-icon>
      </button>
    }
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- Dynamic form fields -->
      <div class="row" [style.vertical-align]="'top'">
        @for (field of fields; track field) {
          <div class="form-group" [ngClass]="['col-sm-' + (field.colSpan || 12), field.key === 'comment' ? 'comment-field' : '']" [hidden]="!isFieldVisible(field)">
            <!-- Text input -->
            @if (field.type === 'text') {
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{field.label}}</mat-label>
                <input matInput
                  [formControlName]="field.key"
                  [placeholder]="field.placeholder || ''">
                  @if (hasError(field.key)) {
                    <mat-error>{{getFieldError(field.key)}}</mat-error>
                  }
                </mat-form-field>
              }
              @if (field.type === 'text' && field.legend) {
                <div class="field-legend">{{field.legend}}</div>
              }
              <!-- Textarea -->
              @if (field.type === 'textarea') {
                <mat-form-field appearance="outline" floatLabel="always">
                  <mat-label>{{field.label}}</mat-label>
                  <textarea matInput
                    [formControlName]="field.key"
                    [rows]="field.rows || 4"
                  [placeholder]="field.placeholder || ''"></textarea>
                  @if (hasError(field.key)) {
                    <mat-error>{{getFieldError(field.key)}}</mat-error>
                  }
                </mat-form-field>
              }
              @if (field.type === 'textarea' && field.legend) {
                <div class="field-legend">{{field.legend}}</div>
              }
              <!-- Number input -->
              @if (field.type === 'number') {
                <mat-form-field appearance="outline" floatLabel="always">
                  <mat-label>{{field.label}}</mat-label>
                  <input matInput
                    type="number"
                    step="1"
                    [formControlName]="field.key"
                    [min]="field.min ?? null"
                    [max]="field.max ?? null"
                    [placeholder]="field.placeholder || ''">
                    @if (hasError(field.key)) {
                      <mat-error>{{getFieldError(field.key)}}</mat-error>
                    }
                  </mat-form-field>
                }
                @if (field.type === 'number' && field.legend) {
                  <div class="field-legend">{{field.legend}}</div>
                }
                <!-- Date input -->
                @if (field.type === 'date') {
                  <mat-form-field appearance="outline">
                    <mat-label>{{field.label}}</mat-label>
                    <input matInput
                      type="date"
                      [formControlName]="field.key"
                      [min]="field.min"
                      [max]="field.max">
                      @if (hasError(field.key)) {
                        <mat-error>{{getFieldError(field.key)}}</mat-error>
                      }
                    </mat-form-field>
                  }
                  @if (field.type === 'date' && field.legend) {
                    <div class="field-legend">{{field.legend}}</div>
                  }
                  <!-- Datetime-local input -->
                  @if (field.type === 'datetime-local') {
                    <mat-form-field appearance="outline">
                      <mat-label>{{field.label}}</mat-label>
                      <input matInput
                        type="datetime-local"
                        [formControlName]="field.key">
                        @if (hasError(field.key)) {
                          <mat-error>{{getFieldError(field.key)}}</mat-error>
                        }
                      </mat-form-field>
                    }
                    @if (field.type === 'datetime-local' && field.legend) {
                      <div class="field-legend">{{field.legend}}</div>
                    }
                    <!-- Select dropdown -->
                    @if (field.type === 'select') {
                      <mat-form-field appearance="outline">
                        <mat-label>{{field.label}}</mat-label>
                        <mat-select [formControlName]="field.key"
                          [required]="!!field.required"
                          [compareWith]="compareValues">
                          @for (opt of field.options; track opt) {
                            <mat-option [value]="opt.value" [ngClass]="{'priority-option': opt.priority}">
                              @if (opt.priority) {<span class="priority-option-star">&#9733;</span>}{{opt.label}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (hasError(field.key)) {
                          <mat-error>{{getFieldError(field.key)}}</mat-error>
                        }
                      </mat-form-field>
                    }
                    @if (field.type === 'select' && field.legend) {
                      <div class="field-legend">{{field.legend}}</div>
                    }
                    @if (field.type === 'autocomplete' || field.type === 'email-chips' || field.type === 'ngselect') {
                      <div class="ng-select-field">
                        <mat-label><span>{{field.label}}</span>@if (field.required) {<span class="orange-asterisk"> *</span>}</mat-label>
                        <ng-select #ngSel
                          [items]="field.suggestions || field.options || []"
                          [multiple]="field.type === 'email-chips'"
                          bindLabel="label"
                          bindValue="value"
                          [searchable]="field.type !== 'ngselect'"
                          [searchFn]="field.type === 'ngselect' ? null : searchUserSuggestion"
                          [closeOnSelect]="field.type !== 'email-chips'"
                          [clearable]="field.type === 'email-chips'"
                          [hideSelected]="field.type === 'email-chips'"
                          [placeholder]="field.placeholder || ''"
                          [formControlName]="field.key"
                          (add)="clearSelectSearch(ngSel)">
                          @if (field.type !== 'ngselect') {
                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                              @if (field.type === 'email-chips') {
                                <span class="ng-value-icon"
                                  role="button"
                                  tabindex="0"
                                  (click)="clear(item)"
                                  (keydown.enter)="clear(item)">×</span>
                              }
                              <span class="ng-value-label" [title]="item.value">{{ item.label }}</span>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                              <div class="user-option">
                                <div class="user-name">{{ item.label }}</div>
                                <div class="user-mail">{{ item.value }}</div>
                              </div>
                            </ng-template>
                          }
                        </ng-select>
                        @if (hasError(field.key)) {
                          <div class="field-error">{{getFieldError(field.key)}}</div>
                        }
                        @if (field.legend) {
                          <div class="field-legend">{{field.legend}}</div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>

              <!-- Action buttons -->
              <div class="row">
                <div class="panel-body">
                  <button type="button"
                    (click)="backButtonHandler($event)"
                    mat-raised-button
                    class="btn button-color-fix"
                    [disabled]="isSubmitting || isDeleting">
                    <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
                    Back
                  </button>
                  @if (showDeleteButton) {
                    <button type="button"
                      (click)="onDelete($event)"
                      mat-raised-button
                      class="btn button-delete"
                      [disabled]="isSubmitting || isDeleting">
                      @if (!isDeleting) {
                        <span>
                          <mat-icon style="color: white;">delete</mat-icon>
                          {{deleteButtonText}}
                        </span>
                      }
                      @if (isDeleting) {
                        <span>
                          Deleting...
                        </span>
                      }
                    </button>
                  }
                  <button mat-raised-button
                    type="submit"
                    class="btn button-color-fix pull-right"
                    [disabled]="!canSubmit || isDeleting">
                    @if (!isSubmitting) {
                      <span>
                        {{submitButtonText}}
                        <mat-icon class="icon-color-fix">save</mat-icon>
                      </span>
                    }
                    @if (isSubmitting) {
                      <span>
                        Saving...
                      </span>
                    }
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
